import { LoanerWheelInventoryActions, GET_MODEL_TYPES, GET_MODEL_TYPES_SUCCESS, GET_TIRE_SIZES_SUCCESS, GET_PROVIDER_LOCATIONS_SUCCESS } from '../actions/loaner-wheel-inventory.action';
import { LoanerWheelInventoryState } from '../state/loaner-wheel-inventory.state';
import { initialState } from '../state/loaner-wheel-inventory.state';

export function LoanerWheelInventoryReducer(state: LoanerWheelInventoryState = initialState, action: LoanerWheelInventoryActions): LoanerWheelInventoryState {
    switch (action.type) {
        case GET_MODEL_TYPES_SUCCESS: {
            return {
                ...state,
                modelTypes: action.payload
            }
        }
        case GET_TIRE_SIZES_SUCCESS: {
            return {
                ...state,
                tireSize: action.payload
            }
        }
        case GET_PROVIDER_LOCATIONS_SUCCESS: {
            return {
                ...state,
                providerLocation: action.payload
            }
        }
        default: return state;
    }
}